import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'fc-empty-layout',
  templateUrl: './empty-layout.component.html',
  standalone: true,
  imports: [RouterOutlet],
})
export class EmptyLayoutComponent {}
